import DateFooterContainer from './DateFooterContainer';

export default DateFooterContainer;



// WEBPACK FOOTER //
// ./src/components/atoms/DateFooter/index.js